import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import {
  ApexAxisChartSeries,
  ApexChart,
  ApexDataLabels,
  ApexMarkers,
  ApexTitleSubtitle,
  ApexFill,
  ApexYAxis,
  ApexXAxis,
  ApexTooltip,
  ApexStroke,
  ApexPlotOptions,
  ApexResponsive,
  ApexNonAxisChartSeries,
  ApexLegend
} from 'ng-apexcharts';
import { AppApexGrid, ChartOptions } from '../../models/chart-options.model';

@Component({
  selector: 'app-apx-chart-wrapper',
  templateUrl: './apx-chart-wrapper.component.html',
  styleUrls: ['./apx-chart-wrapper.component.scss']
})
export class ApxChartWrapperComponent implements OnChanges {
  public chartOptions: ApexChart = { type: 'line' };

  /** All options as one object */
  @Input() options: Partial<ChartOptions> = {};
  // * options separated to other objects
  @Input() series: ApexAxisChartSeries | ApexNonAxisChartSeries = [];
  @Input() chart: ApexChart = this.chartOptions;
  @Input() dataLabels: ApexDataLabels = {};
  @Input() markers: ApexMarkers = {};
  @Input() title: ApexTitleSubtitle = {};
  @Input() fill: ApexFill = {};
  @Input() yaxis: ApexYAxis = {};
  @Input() xaxis: ApexXAxis = {};
  @Input() tooltip: ApexTooltip = {};
  @Input() stroke: ApexStroke = {};
  @Input() plotOptions: ApexPlotOptions = {};
  @Input() grid: AppApexGrid = {};
  @Input() colors: string[] = [];
  @Input() labels: string[] = [];
  @Input() responsive: ApexResponsive[] = [];
  @Input() legend: ApexLegend = {};

  private readonly NO_TOOLBAR = { zoom: { enabled: false }, toolbar: { show: false } };

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.options && changes.options.currentValue.chart) {
      this.chartOptions = { ...changes.options.currentValue.chart, ...this.NO_TOOLBAR };
    }
    if (changes.chart) {
      this.chartOptions = { ...changes.chart.currentValue, ...this.NO_TOOLBAR };
    }
  }
}
